export function Pager({
  page,
  totalPages,
  onChange,
}: {
  page: number;
  totalPages: number;
  onChange: (p: number) => void;
}) {
  if (totalPages <= 1) return null;
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  return (
    <nav className="flex flex-wrap items-center justify-center gap-2 mt-10 not-prose" aria-label="Paginación">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="px-3 py-2 text-sm border border-[var(--color-outline-variant)] hover:border-[var(--color-brand-coral)] disabled:opacity-40 disabled:cursor-not-allowed"
      >
        ← Anterior
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          aria-current={p === page ? "page" : undefined}
          className={
            "px-3 py-2 text-sm border transition-colors " +
            (p === page
              ? "bg-[var(--color-brand-purple)] text-white border-[var(--color-brand-purple)]"
              : "border-[var(--color-outline-variant)] hover:border-[var(--color-brand-coral)]")
          }
        >
          Hoja {p}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="px-3 py-2 text-sm border border-[var(--color-outline-variant)] hover:border-[var(--color-brand-coral)] disabled:opacity-40 disabled:cursor-not-allowed"
      >
        Siguiente →
      </button>
    </nav>
  );
}
